$(document).ready(function () {
  $(".banners_list").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1251,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });

  $(".testimonials-section .testimonials_slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });
  
});





jQuery(document).ready(function($) {
  	// instantiate the accordion
  $('#example1').accordionSlider({
      width: 1600,
      height: 576,
      responsiveMode: 'auto',
      visiblePanels: 4,
      closePanelsOnMouseOut: false,
      autoplay: false
  });

  // change the responsive mode
  $('.controls a').click(function(event) {
      event.preventDefault();

      if ($(this).hasClass('auto')) {
          // change the responsive mode to 'auto' and remove the 'custom-responsive' class
          $('#example1').removeClass('custom-responsive');
          $('#example1').accordionSlider('responsiveMode', 'auto');

          // change the arrows' visibility
          $('.auto-arrow').show();
          $('.custom-arrow').hide();
      } else if ($(this).hasClass('custom')) {
          // change the responsive mode to 'custom' and add the 'custom-responsive'
          // class in order to use it as a reference in the CSS code
          $('#example1').addClass('custom-responsive');
          $('#example1').accordionSlider('responsiveMode', 'custom');

          // change the arrows' visibility
          $('.custom-arrow').show();
          $('.auto-arrow').hide();
      }
  });
});